module.exports = __webpack_public_path__ + "static/media/RecordVideo.ac255321.svg";